import { StylesConfig } from 'react-select';

type OptionType = {
  value: string;
  label: string;
};

export const customStyles: StylesConfig<OptionType, true> = {
  container: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 100,
    width: '150px',
  }),
  control: (styles) => ({
    ...styles,
    cursor: 'pointer',
  }),
  placeholder: (base: Record<string, unknown>) => ({
    ...base,
    display: 'block',
    color: '#000',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  }),
  menu: (styles) => ({
    ...styles,
    width: '300px',
    maxHeight: '500px',
  }),
  menuList: (styles) => ({
    ...styles,
    width: '300px',
    maxHeight: '500px',
  }),
  option: (styles) => ({
    ...styles,
    width: '300px',
    paddingLeft: '16px',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 600,
    color: '#000',
    paddingLeft: '16px',
    marginBottom: '10px',
  }),
};

export const productListStyles: StylesConfig<OptionType, true> = {
  container: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 100,
    width: 'fit-content',
    '@media (max-width: 768px)': {
      zIndex: 50,
    },
  }),
  control: (styles) => ({
    ...styles,
    cursor: 'pointer',
    borderRadius:'25px',
    minHeight:'40px',
    padding: '0.25rem 1rem',
    backgroundColor:'#003359',
    color:'white',
    borderColor:'white',
    "&:hover": {
      borderColor: "white",
      cursor: "pointer"
    }
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    width: 'fit-content',
    padding: '0px',
  }),
  placeholder: (base: Record<string, unknown>) => ({
    ...base,
    display: 'block',
    color:'#fff',
    fontSize: '14px',
    fontWeight: 400,
  }),
  menu: (styles) => ({
    ...styles,
    width: 'fit-content',
    maxWidth: '200px',
    maxHeight: '500px',
    color:'black',
    borderRadius: '8px',
    right: '0',
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    width: '0px'
  }),
  menuList: (styles) => ({
    ...styles,
    width: 'fit-content',
    padding: '4px',
    maxHeight: '500px',
    borderRadius: '8px',
    "&:hover": {
      borderColor: "white"
    }
  }),
  option: (styles) => ({
    ...styles,
    width: 'fit-content',
    maxHeight: '60px',
    backgroundColor: '#FFFFFF',
    padding: '8px 16px',
    "&:hover": {
      backgroundColor: "#F4F5F7",
      borderRadius: 'var(--radius-075, 6px)'
    }
  }),
  singleValue: (styles) => ({
    ...styles,
    color: 'white'
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 600,
    paddingLeft: '16px',
    marginBottom: '10px'
  }),
};

